import { IUser } from 'app/models/user';

export const AUTH_LOGIN = '[Auth] Login';
export const AUTH_LOGOUT = '[Auth] Logout';
export const AUTH_AUTO_LOGIN = '[Auth] Auto Login';

//intefaces
export interface Login {
  type: typeof AUTH_LOGIN;
  payload: { user: IUser };
}

export interface Logout {
  type: typeof AUTH_LOGOUT;
}

export interface AutoLogin {
  type: typeof AUTH_AUTO_LOGIN;
}

//action creators
export const login = (user: IUser): Login => {
  return {
    type: AUTH_LOGIN,
    payload: { user },
  };
};

export const logout = (): Logout => {
  return {
    type: AUTH_LOGOUT,
  };
};

export const autoLogin = (): AutoLogin => {
  return {
    type: AUTH_AUTO_LOGIN,
  };
};

export type AuthTypes = Login | Logout | AutoLogin;